/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FormControl, InputLabel, Grid, MenuItem, Select } from "@mui/material";
import { FC, useState } from "react";
import { useTaskRegisterDataContext } from "context/TaskRegisterDataProvider";
import { UserInfo } from "hooks/GetUsersHook";

interface UserSelectorProps {
  label?: string;
  userId?: string;
  disabled?: boolean;
  onSelected?: (userId: string) => void;
}
export const UserSelector: FC<UserSelectorProps> = ({
  label,
  userId,
  disabled,
  onSelected,
}) => {
  const { users } = useTaskRegisterDataContext();
  const [selectedUserId, setSelectedUserId] = useState(userId);
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs={11.5}>
        <FormControl fullWidth>
          <InputLabel>{label}</InputLabel>
          <Select
            sx={{ width: "100%" }}
            size="small"
            label={label}
            value={selectedUserId ?? ""}
            onChange={(e) => {
              setSelectedUserId(e.target.value);
              onSelected?.(e.target.value);
            }}
            disabled={disabled}
          >
            {users?.map((user: UserInfo) => (
              <MenuItem key={user.id} value={user.id}>
                {user.fullName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};
